import styled, { css } from "styled-components"
import withAnimation from "../../design-system/util/withAnimation"
import Breakpoints from "../shared/breakpoints"
import { GridContainer, LayoutContainer } from "../shared/grid.style"
import {
  desktopTextStyles,
  mobileTextStyles,
  tabletTextStyles,
} from "../shared/typography.styles"

export const Container = styled.div`
  & ${LayoutContainer} {
    padding: 32px 0;
    @media (min-width: ${Breakpoints.md}) {
      padding: 96px 0;
    }
  }

  & ${GridContainer} {
    grid-template-rows: 40vw auto;

    @media (min-width: ${Breakpoints.md}) {
      grid-template-rows: auto;
    }
  }
`
export const GridOverlay = css`
  background-color: var(--tricorn-black);
`

export const MobileImage = styled.img`
  grid-column: 2 / -2;
  opacity: 0.5;

  grid-row: 1 / 3;

  @media (min-width: ${Breakpoints.md}) {
    display: none;
  }
`

export const HeaderContainer = styled.div`
  grid-column: 1 / -1;
  grid-row: 2 / 4;
  z-index: 10;

  @media (min-width: ${Breakpoints.md}) {
    grid-row: unset;
  }
`

export const HeaderContainerInner = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: left;
  flex-wrap: wrap;

  @media (min-width: ${Breakpoints.md}) {
    align-items: center;
    text-align: center;
  }
  @media (min-width: ${Breakpoints.lg}) {
  }
`

export const SectionTitle = withAnimation(styled.h3`
  flex-basis: 100%;

  color: var(--white);

  ${mobileTextStyles.MobileHeadingTwoRegular}

  & > span {
    font-weight: 500;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletHeadingTwoRegular}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeRegular}
  }
`)

export const TitleDescription = withAnimation(styled.p`
  ${mobileTextStyles.MobileBodyRegular}

  @media (min-width: ${Breakpoints.md}) {
    ${tabletTextStyles.TabletBodyRegular}
    max-width: 100%;
  }
  @media (min-width: ${Breakpoints.lg}) {
    max-width: 65%;
    ${desktopTextStyles.BodyText18}
  }

  color: var(--dark-mode-heading);
  margin-top: 32px;
`)

export const MapLabel = styled.p`
  @media (max-width: ${Breakpoints.md}) {
    display: flex;
    justify-content: flex-start;
    width: 270px;
    margin-bottom: 18px;

    & > span:first-child {
      display: block;
      min-width: 100px;
      text-align: right;
      padding-right: 24px;
    }

    & > span:last-child {
      flex-grow: 1;
    }
  }

  position: absolute;
  top: ${(props) => `${props.top}%`};
  left: ${(props) => `${props.left}%`};
  display: flex;
  align-items: center;
  color: var(--dark-mode-heading);

  & > span:nth-child(1) {
    ${desktopTextStyles.HeadingOneRegular}
    font-weight: 500;
    margin-right: 8px;
    @media (max-width: ${Breakpoints.lg}) {
      font-size: 32px;
    }
  }

  & > span:nth-child(2) {
    ${desktopTextStyles.HeadingSixRegular}

    @media (max-width: ${Breakpoints.lg}) {
      font-size: 11px;
    }
  }
`

export const MapContainer = withAnimation(styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: ${Breakpoints.md}) {
    grid-column: 1 / -1;
    margin-top: 54px;
    & > img {
      display: none;
    }
    & ${MapLabel} {
      position: initial !important;
      top: initial !important;
      left: initial !important;
    }
  }

  @media (min-width: ${Breakpoints.md}) {
    & > img {
      display: initial;
    }

    grid-column: 3 / 12;
    position: relative;
    margin-top: 64px;
  }
`)
